import { LOCALES, Locale } from "@divespots/contracts";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useLocale } from "../i18n/index.ts";
import { GlassSelect } from "./GlassSelect.tsx";

/** Switches the `/:lang` URL segment, keeping the rest of the path. */
export function LanguageSelect({ plain = false }: { plain?: boolean }) {
  const { t } = useTranslation();
  const locale = useLocale();
  const navigate = useNavigate();
  const { pathname, search, hash } = useLocation();

  const change = (next: string) => {
    const parsed = Locale.safeParse(next);
    if (!parsed.success) return;
    const rest = pathname.split("/").slice(2).join("/");
    void navigate(`/${parsed.data}/${rest}${search}${hash}`);
  };
  if (plain) {
    // Admin pages sit on bg / bg-elevated, not on glass.
    return (
      <select
        className="adm-input adm-langselect"
        aria-label={t("language.label")}
        value={locale}
        onChange={(e) => change(e.target.value)}
      >
        {LOCALES.map((l) => (
          <option key={l} value={l}>
            {l.toUpperCase()}
          </option>
        ))}
      </select>
    );
  }
  return (
    <GlassSelect
      label={t("language.label")}
      value={locale}
      options={LOCALES.map((l) => ({ value: l, label: l.toUpperCase() }))}
      onChange={(next) => {
        const parsed = Locale.safeParse(next);
        if (!parsed.success) return;
        const rest = pathname.split("/").slice(2).join("/");
        void navigate(`/${parsed.data}/${rest}${search}${hash}`);
      }}
    />
  );
}
